var _defs, _path, _rect, _rect2, _path2, _path3, _rect3, _polygon, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSihaBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fd087900-30dd-4ca8-b5c5-d59fb9abba6e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".efca2833-7f49-4f7a-a859-f41d0c681906{fill:url(#06dca4b7-51d3-4355-94fa-609726093ebd);}.cc7c5f17-30e8-45f3-b894-c967111ae793{fill:url(#0e1babb0-e38b-4e24-b765-91be3508f313);}.c6e9cbe8-31bb-4e1c-adbe-579f93969313{fill:url(#b669a034-a5f6-4c8f-9b7a-1bca4b4436ea);}.\\38 b9e36b8-ef0e-48d7-9622-f91ce6c17500{fill:url(#d155b47a-9de6-44f1-9fcf-18d624617213);}.a3ad7cc1-d045-466d-a50c-58714bdbbf0b{fill:url(#d847539b-2c26-48a4-be6d-0092ec2eb458);}.bea3c589-141c-4994-b261-24885338219b{fill:url(#a585f8d0-6427-4909-b465-65c2db3e7558);}.\\32 c0c1e96-40a8-4d37-b008-f5d1c9a3519f{fill:url(#e3dfd9f0-1816-4c60-bd51-ebe2295f80c2);}.\\32 c1e591a-4d3e-4d2a-816f-d15989ac13fc{fill:url(#06cd114d-ad1f-4d5e-9914-7e3f852cd1ba);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "06dca4b7-51d3-4355-94fa-609726093ebd",
    x1: 5.41,
    y1: 50.87,
    x2: 107.18,
    y2: 50.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37499e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30439a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#304099"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0e1babb0-e38b-4e24-b765-91be3508f313",
    x1: 146.41,
    y1: 5.98,
    x2: 151.41,
    y2: 5.98,
    xlinkHref: "#06dca4b7-51d3-4355-94fa-609726093ebd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b669a034-a5f6-4c8f-9b7a-1bca4b4436ea",
    x1: 142.15,
    y1: 5.98,
    x2: 147.16,
    y2: 5.98,
    xlinkHref: "#06dca4b7-51d3-4355-94fa-609726093ebd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d155b47a-9de6-44f1-9fcf-18d624617213",
    x1: 130.8,
    y1: 24.3,
    x2: 226.76,
    y2: 24.3,
    xlinkHref: "#06dca4b7-51d3-4355-94fa-609726093ebd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d847539b-2c26-48a4-be6d-0092ec2eb458",
    x1: 113.66,
    y1: 68.79,
    x2: 150.48,
    y2: 68.79,
    xlinkHref: "#06dca4b7-51d3-4355-94fa-609726093ebd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a585f8d0-6427-4909-b465-65c2db3e7558",
    x1: 156.33,
    y1: 68.79,
    x2: 162.45,
    y2: 68.79,
    xlinkHref: "#06dca4b7-51d3-4355-94fa-609726093ebd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e3dfd9f0-1816-4c60-bd51-ebe2295f80c2",
    x1: 169.87,
    y1: 68.79,
    x2: 206.16,
    y2: 68.79,
    xlinkHref: "#06dca4b7-51d3-4355-94fa-609726093ebd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "06cd114d-ad1f-4d5e-9914-7e3f852cd1ba",
    x1: 207.71,
    y1: 68.79,
    x2: 251,
    y2: 68.79,
    xlinkHref: "#06dca4b7-51d3-4355-94fa-609726093ebd"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SIHA-Blue-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "efca2833-7f49-4f7a-a859-f41d0c681906",
    d: "M80.64,5.16c-17.2,0-26,16-29.33,22l-.69,1.25-.81,1.45C46.9,35.17,41.47,45,32,45a13.14,13.14,0,1,1,0-26.28,14.12,14.12,0,0,1,8.78,3.18l.39-.69A78.84,78.84,0,0,1,48,10.58,26.49,26.49,0,0,0,5.41,31.88,26.66,26.66,0,0,0,32,58.59c17.2,0,26-16,29.33-22l.7-1.25.81-1.45c2.91-5.29,8.33-15.14,17.85-15.14A13.26,13.26,0,0,1,94,31.87c0,20.09-24.75,40.48-37.69,49a65.17,65.17,0,0,1-9-6.7,6.41,6.41,0,0,0-4.65-1.52h-.18c-5.87.45-8.2,8.05-3.65,11.9C48,92.29,52.25,94.2,53,94.66l3.28,1.93,3.27-1.93c2-1.14,47.61-28.47,47.6-62.79A26.65,26.65,0,0,0,80.64,5.16Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cc7c5f17-30e8-45f3-b894-c967111ae793",
    x: 146.41,
    y: 3.35,
    width: 5,
    height: 5.26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c6e9cbe8-31bb-4e1c-adbe-579f93969313",
    x: 142.15,
    y: 3.35,
    width: 5,
    height: 5.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "8b9e36b8-ef0e-48d7-9622-f91ce6c17500",
    d: "M187.69,35.7h39.07c0-5.26-.57-9.32-1.77-12.19a10.77,10.77,0,0,0-9.33-6.87A13.19,13.19,0,0,0,208,18.57a19.23,19.23,0,0,0-8.18,9.22V21.64H194.3l.11,9H183.57c-.62-4.22-2-7.6-4.11-10a12.44,12.44,0,0,0-10.06-4.43c-4.06,0-7.14.88-9.22,2.71l2.14,4.27c1.46-1.2,3.75-1.77,6.93-1.77,5,0,8,3.07,9.06,9.27H151.12c-1.41,0-2.14-.88-2.14-2.6l0-14.75h-5.47v1.88h-.11a6.07,6.07,0,0,0-5-2.29A6.73,6.73,0,0,0,133.45,15q-2.65,2.58-2.65,7.5c0,5.06,2.08,7.56,6.2,7.56h6.51c0,3.75,1.82,5.62,5.52,5.62h38.66Zm26.62-14.17a10.91,10.91,0,0,1,1.2.11q3.44.39,4.84,4.22a12,12,0,0,1,.84,4.58v.21H202.8C205.92,24.56,209.78,21.53,214.31,21.53ZM138.92,25a2.32,2.32,0,0,1-2.55-2.5c-.15-2.76.94-4.16,3.34-4.16a4.32,4.32,0,0,1,3.75,2.39l0,4.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a3ad7cc1-d045-466d-a50c-58714bdbbf0b",
    d: "M142.59,67.56a61.59,61.59,0,0,0-10.23-3q-7.47-1.68-9.23-3.29a5.27,5.27,0,0,1-1.8-4.1,6.12,6.12,0,0,1,2.54-4.91c1.69-1.36,4.39-2,8.09-2s6.24.74,8.06,2.24a9.43,9.43,0,0,1,3.2,6.62l5.87-.44a14,14,0,0,0-2.27-7.29,13.07,13.07,0,0,0-6-4.87,23.08,23.08,0,0,0-9.07-1.66,22.1,22.1,0,0,0-8.49,1.58,12.28,12.28,0,0,0-5.8,4.62,11.72,11.72,0,0,0-2,6.55,10.55,10.55,0,0,0,1.62,5.75A12.55,12.55,0,0,0,122,67.69a42.41,42.41,0,0,0,8.93,2.89,82.6,82.6,0,0,1,8.23,2.25,9.39,9.39,0,0,1,4.17,2.73,6,6,0,0,1,1.26,3.8,6.65,6.65,0,0,1-1.31,4,8.59,8.59,0,0,1-4,2.86,17.1,17.1,0,0,1-6.18,1,17.7,17.7,0,0,1-7.1-1.37,10.38,10.38,0,0,1-4.65-3.6,12.68,12.68,0,0,1-1.91-5.69l-5.78.5a15.65,15.65,0,0,0,2.54,8.31,14.76,14.76,0,0,0,6.66,5.51,26.62,26.62,0,0,0,10.52,1.83,21.15,21.15,0,0,0,8.91-1.82,13.9,13.9,0,0,0,6.08-5.07,12.59,12.59,0,0,0,2.11-7,11.51,11.51,0,0,0-1.92-6.58A14.14,14.14,0,0,0,142.59,67.56Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "bea3c589-141c-4994-b261-24885338219b",
    x: 156.33,
    y: 45.67,
    width: 6.12,
    height: 46.25
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "2c0c1e96-40a8-4d37-b008-f5d1c9a3519f",
    points: "200.04 64.66 176 64.66 176 45.67 169.88 45.67 169.88 91.92 176 91.92 176 70.12 200.04 70.12 200.04 91.92 206.16 91.92 206.16 45.67 200.04 45.67 200.04 64.66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "2c1e591a-4d3e-4d2a-816f-d15989ac13fc",
    d: "M232.07,45.67h-6.59L207.71,91.92h6.5l5.08-14h19.34l5.4,14h7Zm-11,27.26,5.08-13.57a59.42,59.42,0,0,0,2.49-8.83q1.08,3.75,3.28,9.59l4.83,12.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSihaBlue);
export default __webpack_public_path__ + "static/media/siha-blue.33ae69d69c8f5aed709957a927edb887.svg";
export { ForwardRef as ReactComponent };